import actionTypes from './userSettings.actionTypes';


export const updateUserSettings = (userSettings) => {
  return { type: actionTypes.UPDATE_USER_SETTINGS, data: userSettings };
};

export const resetUserSettingsState = () => {
  return { type: actionTypes.RESET_USER_SETTINGS };
};